import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for match filters query
const CACHE_TIME = 30 * 60 * 1000;

export const useMatchFiltersQuery = () => {
  return useQuery({
    queryKey: ['match-filters'],
    queryFn: fetchMatchFilters,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

const fetchMatchFilters: QueryFunction<any[], [string]> = async () => {
  const { data } = await axios.get<any[]>(API.endpoints.matchFilters);
  return data;
};
